/*jshint esversion: 6 */
jQuery(function($) {


   /******************************************/
    /********** MENU HOVER -----------/
  /******************************************/

var $masthead = $('#masthead');
  $('#primary-menu > li').hover(
  function() {
    $masthead.addClass('open-menu');
  }, function() {
     $masthead.removeClass('open-menu');
  }
);

$( ".g_over_width_arrow" ).hover(
  function() {
    $( ".SchemaExpertiseContainer" ).addClass('recArrow');
  }, function() {
   $( ".SchemaExpertiseContainer" ).removeClass('recArrow');
  }
);


  
  /* SCHEMA SECTEUR D'ACTIVITE*/
  const swiper_slider = new Swiper('.swiper_secteur', {
  slidesPerView: 1.3,
  spaceBetween: 10,
    speed: 900,
    centeredSlides: true,
    slideToClickedSlide: false,
    preventClicks:false,
    preventClicksPropagation:false,
  breakpoints: {
    500: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 1,
        spaceBetween: 20,
      }
  }

});



var width_window = $(window).width();


  /* Secteur */
    /* if in tab mode */
    $(".g_expertise_parent").click(function() {

      let activeTab = $(this).attr('id');
      let newStr = activeTab.replace('bl_x5F_', '');

       if($(this).hasClass('active')){
        //$("#"+activeTab).slideUp(400); 
        //$(this).removeClass('active');
        //$('.Tabs-Liste').removeClass('one-item-active');

      }else{
        swiper_slider.slideTo( $('#sTxt_'+newStr).index(),300,false );
        $('.g_expertise_parent').removeClass('active');
        $(this).addClass('active');
      }


      if(width_window < 769){
     let offsetTopThisOne = $('#schema-secteur').offset().top-topMenuHeight-50-80;
      $('html, body').stop().animate({ 
          scrollTop: offsetTopThisOne
      }, 500);
   }

    
    });



  $( ".NS-Block__inner" ).each(function() {
    var $icon =   $( this ).find( "i" );
    if($icon){
      $(this).find('h2').prepend($icon);
    }
  });

  /* SCHEMA EXPERTISE */
    const swiper_expertise = new Swiper('.swiper_expertise', {
  // Optional parameters
  slidesPerView: 1.3,
  spaceBetween: 10,
 // loop: false,
    speed: 900,
    centeredSlides: true,
    slideToClickedSlide: false,
    preventClicks:false,
    preventClicksPropagation:false,
  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
 // watchSlidesProgress: true,
  breakpoints: {
    500: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 1,
        spaceBetween: 20,
      }
  }

});


    
/* Expertise */
$(".hoverelt").click(function() {

  let activeTab = $(this).attr('data-destid');
 
   if($(this).hasClass('active')){

  }else{

    $( ".SchemaExpertiseContainer").removeClass('recArrowBis');
    if(activeTab == 'design_dev'){
      $( ".SchemaExpertiseContainer").addClass('recArrowBis');
    }
    swiper_expertise.slideTo( $('#'+activeTab).index(),500,false );
    $('.hoverelt').removeClass('active');
    $(this).addClass('active');
  }


   if(width_window < 769){
     let offsetTopThisOne = $('#schema-expertise').offset().top-topMenuHeight-50-80;
      $('html, body').stop().animate({ 
          scrollTop: offsetTopThisOne
      }, 500);
   }
});


    
  // FORM CONTACT LABEL ///

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });


/**********************************/
/******GALERIE ****/
/**********************************/

$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
 // adaptiveHeight: true,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});

$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
 // centerMode: true,
  focusOnSelect: true,
    responsive: [
    {
      breakpoint: 1025, // = 1024
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows:false,
         centerMode: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
         centerMode: false,
        arrows:false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  /***************** PAGE Téléchargement **********************/

   $('#download_datatable').DataTable(
      {
        iDisplayLength:100,
        lengthChange: false,
        // "language": {
        //     "lengthMenu": "Display _MENU_ records per page",
        //     "zeroRecords": "Nothing found - sorry",
        //     "info": "Showing page _PAGE_ of _PAGES_",
        //     "infoEmpty": "No records available",
        //     "infoFiltered": "(filtered from _MAX_ total records)"
        // }
        "language": {
            "lengthMenu": string_value.datatable_1,
            "zeroRecords": string_value.datatable_2,
            "info": string_value.datatable_3,
            "infoEmpty": string_value.datatable_4,
            "infoFiltered": string_value.datatable_5,
            "loadingRecords": string_value.datatable_6,
            "processing":string_value.datatable_7,
            "search":string_value.datatable_8,
            "paginate": {
              "first":      string_value.datatable_9,
              "last":       string_value.datatable_10,
              "next":       string_value.datatable_11,
              "previous":   string_value.datatable_12
          },

        }
     });



  var topMenuHeight = $("#masthead").height();
  var other_link =  $('.to_bottom_round, .to_bottom');
  other_link.click(function(e){
    
    var href = $(this).attr("href");

    if(href.indexOf('/') !== -1){
      var array_href = href.split(/[/]/);
      href = array_href[array_href.length-1];
   }
      
        var offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight-50;
      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 500);
      e.preventDefault();
  });




   //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();
   


});

